module.exports = __webpack_public_path__ + "img/g.b27d58e6.jpg";